// Frontend-only additions to the Firestore schedule. Use these for:
//   - Days where Firestore has no lunch event (Days 6, 9, 10).
//   - Day-level annotations (e.g. Day 5 afternoon Codingbat review).
// These are NEVER written to Firestore — they only appear on the landing.

export type Supplement = {
  id: string;
  type: 'break' | 'note';
  title: string;
  start: number;
};

// Keyed by 1-based day number.
export const SUPPLEMENTS: Record<number, Supplement[]> = {
  5: [
    {
      id: 'day5-afternoon-note',
      type: 'note',
      title: 'Afternoon: Codingbat review and practice',
      start: 13.5,
    },
  ],
  6: [
    { id: 'lunch6-synthetic', type: 'break', title: 'Lunch', start: 12.5 },
  ],
  9: [
    { id: 'lunch9-synthetic', type: 'break', title: 'Lunch', start: 12.5 },
  ],
  10: [
    { id: 'lunch10-synthetic', type: 'break', title: 'Lunch', start: 12.5 },
    {
      id: 'day10-afternoon-note',
      type: 'note',
      title: 'Afternoon: Celebration and wrap-up',
      start: 13.5,
    },
  ],
};
